export default __webpack_public_path__ + "static/media/sous-terre.88a7b331.svg";